import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

function LoadingCreatorFragment() {
  return (
    <FixaSkeleton
      width="100%"
      height="73px"
      data-testid="loading-creator-fragment"
    />
  );
}

export default LoadingCreatorFragment;
